// 從 Excel 檔案解析出的任務預設資料
export const TASK_PRESETS = {
  0: {
    name: '問卷',
    defaultTask: {
      name: '病人相似性：改善醫療保健',
      description: '病人相似性是如何被利用於改善醫療保健呢？',
      link: 'https://devwebbj.dsigroup.com.tw/P241219171900716/',
      targetValue: 1,
      reward: 1,
    },
  },
  1: {
    name: '飲水',
    defaultTask: {
      name: '喝水',
      description: '來填寫今日喝水紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  2: {
    name: '飲食',
    defaultTask: {
      name: '飲食',
      description: '來填寫今日飲食紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  3: {
    name: '心情',
    defaultTask: {
      name: '心情',
      description: '來填寫今日心情紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  4: {
    name: '排便',
    defaultTask: {
      name: '排便',
      description: '來填寫今日排便紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  5: {
    name: '睡眠',
    defaultTask: {
      name: '睡眠',
      description: '來填寫今日睡眠紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  6: {
    name: '運動',
    defaultTask: {
      name: '運動',
      description: '來填寫今日運動紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  7: {
    name: '血壓',
    defaultTask: {
      name: '血壓',
      description: '來填寫今日血壓紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  8: {
    name: '步行 6 分鐘',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  9: {
    name: '授權書',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  10: {
    name: '授權書列表',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  11: {
    name: '通用',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  12: {
    name: '血糖',
    defaultTask: {
      name: '血糖',
      description: '來填寫今日血糖紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  13: {
    name: '飲食搭配圖片上傳',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  14: {
    name: '健檢報告上傳',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
  15: {
    name: '預約健檢平台',
    defaultTask: {
      name: '健檢預約',
      description: '來完成健檢預約吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 0,
    },
  },
  16: {
    name: '處方箋啟動任務',
    defaultTask: {
      name: '啟動 AI 個人化處方',
      description: '點選查看你的專屬健康分數，設立健康目標！',
      link: 'App 頁面',
      targetValue: 1,
      reward: 0,
    },
  },
  17: {
    name: '體重',
    defaultTask: {
      name: '體重',
      description: '來填寫今日體重紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  18: {
    name: '腰臀圍',
    defaultTask: {
      name: '腰臀圍',
      description: '來填寫今日腰臀圍紀錄吧',
      link: 'App 頁面',
      targetValue: 1,
      reward: 1,
    },
  },
  99: {
    name: 'APP 操作',
    defaultTask: {
      name: '',
      description: '',
      link: 'App 頁面',
      targetValue: 0,
      reward: 0,
    },
  },
}

// 重複選項配置
export const REPEAT_OPTIONS = [
  { value: 'none', label: '不重複（僅可一次性完成）' },
  { value: 'daily', label: '每日推送' },
  { value: 'weekly', label: '每週推送' },
  { value: 'monthly', label: '每月推送' },
  { value: 'yearly', label: '每年推送' },
]

// 運動項目選項
export const EXERCISE_OPTIONS = [
  { value: '0', label: '游泳' },
  { value: '1', label: '攀岩' },
  { value: '2', label: '走路' },
  { value: '3', label: '慢跑' },
  { value: '4', label: '排球' },
  { value: '5', label: '保齡球' },
  { value: '6', label: '高爾夫球' },
  { value: '7', label: '乒乓球' },
  { value: '8', label: '棒壘球' },
  { value: '9', label: '羽球' },
  { value: '10', label: '網球' },
  { value: '11', label: '足球' },
  { value: '12', label: '籃球' },
  { value: '13', label: '溜冰或直排輪' },
  { value: '14', label: '腳踏車或飛輪' },
  { value: '15', label: '瑜珈、太極等伸展律動性舞蹈' },
  { value: '16', label: '有氧或快節奏舞蹈' },
  { value: '99', label: '其他' },
]

// 連結型任務類型（可以自定義連結的任務）
export const LINK_TYPE_TASKS = [0] // 問卷、預約健檢平台等可能需要外部連結

const taskConstants = {
  TASK_PRESETS,
  REPEAT_OPTIONS,
  EXERCISE_OPTIONS,
  LINK_TYPE_TASKS,
}

export default taskConstants
